const environment = require('./environment');
const argv = process ? require('minimist')(process.argv.slice(2)) : {};

const { ENVIRONMENT } = 'undefined' !== typeof window ? window.env : argv['ENVIRONMENT'] ? argv : process.env;

const buildConfig = environment[ENVIRONMENT || 'development'] || {};

const sentryURL = 'https://16a8291a236a41fe8f36d3fd90c09774@sentry.io/173759';

const sentryOptions = {
  // List of common ignore rules from https://docs.sentry.io/clients/javascript/tips/
  ignoreErrors: [
    /Blocked a frame with origin/,
    // Random plugins/extensions
    'top.GLOBALS',
    // See: https://blog.errorception.com/2012/03/tale-of-unfindable-js-error. html
    'originalCreateNotification',
    'canvas.contentDocument',
    'MyApp_RemoveAllHighlights',
    'https://tt.epicplay.com',
    'Can\'t find variable: ZiteReader',
    'jigsaw is not defined',
    'ComboSearch is not defined',
    'https://loading.retry.widdit.com/',
    'atomicFindClose',
    // happening only for old android devices (<= 4.4) so it's probably safe to ignore
    'INVALID_STATE_ERR: DOM Exception 11',
    // happening only for android 7.1.1, chrome mobile 45.0.2454
    'Cannot read property \'end\' of undefined',
    'Cannot read property \'DOMNodeInsertedByJs\' of undefined',
    'Cannot read property \'onWindowLoaded\' of undefined',
    // Facebook borked
    'fb_xd_fragment',
    // ISP "optimizing" proxy - `Cache-Control: no-transform` seems to
    // reduce this. (thanks @acdha)
    // See https://stackoverflow.com/questions/4113268
    'bmi_SafeAddOnload',
    'EBCallBackMessageReceived',
    // See https://toolbar.conduit.com/Developer/HtmlAndGadget/Methods/JSInjection.aspx
    'conduitPage',
    // failed to load favicon, url seems to be working, we can probably ignore this for now...
    // Only seems to be for Chrome v.57.0.2987 and Windows 10, can't replicate
    'Failed to execute \'send\' on \'XMLHttpRequest\': Failed to load \'https://images.hu-production.be/static/favicon.png\'.',
    'Non-Error promise rejection captured', // TECH-52

    // not much we can do about the user's internet connection being rubbish
    'Network Error',

    // Login error messages
    'Email/password combination isn\'t right or email already in use',
    'La combinación de correo electrónico / contraseña no es correcta o el correo electrónico ya está en uso', //es
    'A combinação de e-mail / senha não está correta ou o e-mail já está em uso', //pt
    'It looks like you left your email address out. Add it and try again!',
    'This email address has already been registered. Already a member? Try \'Log in\' below.',
    'Your account has been locked. Please reset your password',
    'Sua conta foi bloqueda. Por favor modifique sua senha para continuar', //pt

    // 404
    'Request failed with status code 404',
    '404: Post error',
    '404: This is a private community',
    // 410 GONE (normally means a post was deleted)
    '410 User is being shown an oops page',
    'Request failed with status code 410',
    '410: Post error',
    // 401
    '401: This page is not available to visitors',
  ],
  whitelistUrls: [
    /d3pv2lg0hr7u1j.cloudfront.net/i,
    /assets.hu-production.be/i,
    /assets.hu-production.be/i,
    /assets.hu-production.be/i,
    /assets.hu-staging.be/i,
  ],
};

module.exports = Object.assign({
  AURORA_API_PATH: 'https://healthunlocked.com/api/',
  SOLARIS_API_PATH: 'https://solaris.healthunlocked.com/',
  DISCOVER_API_PATH: 'https://discover-api.hu-production.be/',
  DISCOVER_API_KEY: '',

  // Run-time
  WS_URL: 'wss://health-unlocked.com/',
  WS_PATH: '/ws',

  USE_DEV_PROXY: false,

  isServer: typeof window === 'undefined',

  cdn: {
    img: buildConfig.IMG_PATH,
    static: `${buildConfig.IMG_PATH}/static/`,
    postImg: `${buildConfig.IMG_PATH}/post/post_/`,
    replyImg: `${buildConfig.IMG_PATH}/response/`,
    communityLogos: `${buildConfig.IMG_PATH}/group-logos/`,
    communityBanners: `${buildConfig.IMG_PATH}/group-banners/`,
    communityPromoImages: `${buildConfig.IMG_PATH}/group-campaigns/`,
    avatars: `${buildConfig.IMG_PATH}/avatars/`,
    userBanners: `${buildConfig.IMG_PATH}/user-banners/`,
    emoji: `${buildConfig.IMG_PATH}/betelgeuse/img/emoji/unicode/`,
    resources: `${buildConfig.IMG_PATH}/resources/`,
    navigator: `${buildConfig.IMG_PATH}/programs/`,
    programs: `${buildConfig.CDN_PATH}/solaris/programs/`,
    tags: `${buildConfig.CDN_PATH}/solaris/tags/`,
    articles: `${buildConfig.CDN_PATH}/solaris/articles/`,
    smiley: 'https://assets.hu-production.be/aurora/images/smiley/',
    bg: 'https://assets.hu-production.be/betelgeuse/img/',
    resourcesIndex: 'https://assets.hu-production.be/betelgeuse/img/index-pages/resources/',
    programsIndex: 'https://assets.hu-production.be/betelgeuse/img/index-pages/programs/',
    localesPath: `${buildConfig.CDN_PATH}/static/locales/`,
    logos: `${buildConfig.IMG_PATH}/static/img/logos/`,
  },

  defaultProfileImage: `${buildConfig.IMG_PATH}/avatars/avatar_hidden_medium_200x200.jpg`,
  defaultCommunityImage: 'https://images.hu-production.be/group-logos/community_logo_default_medium_200x200.jpg',

  avatars: {
    smallSuffix: '_small@2x_100x100.jpg',
    mediumSuffix: '_medium@2x_400x400.jpg',
  },

  groups: {
    bannerSuffix: '_1170x250@2x.jpg',
    bannerSuffixSmall: '_1170x250.jpg',
    logoSuffix: '_140x140@2x.jpg',
    logoSuffixSmall: '_50x50@2x.jpg',
  },

  roles: {
    restricted: 30,
  },

  fb: {
    page: 'https://www.facebook.com/healthunlocked',
    appId: '542626299164413',
    scope: 'public_profile,email,user_birthday',
  },

  google: {
    clientId: '597276905358-r3l7ftfs10mu2jnttvme4pl3p2moaqq5.apps.googleusercontent.com',
  },

  authTypes: {
    facebook: 0,
    google: 1,
  },

  api: {
    communityTypes: {
      EDITORIAL: 8,
    },
    postTypes: {
      POST: 4,
      QUESTION: 1,
      POLL: 6,
      POLL_CHOICE: 7,
      ANSWER: 2,
      COMMENT: 19,
    },
  },

  community: {
    en: {
      support: 'https://support.healthunlocked.com',
      blog: 'https://blog.healthunlocked.com/',
      fb: 'https://www.facebook.com/healthunlocked',
      twitter: 'https://twitter.com/healthunlocked',
      lockPost: 'https://support.healthunlocked.com/article/36-turn-off-replying-on-posts',
    },
    es: {
      support: 'https://support.healthunlocked.com',
      blog: 'https://blog.healthunlocked.com/',
      fb: 'https://www.facebook.com/huespanol',
      twitter: 'https://twitter.com/huespanol',
      lockPost: 'https://support.healthunlocked.com/article/36-turn-off-replying-on-posts',
    },
    pt: {
      support: 'https://support.healthunlocked.com',
      blog: 'https://blog.healthunlocked.com/',
      fb: 'https://www.facebook.com/huportugues',
      twitter: 'https://twitter.com/huportugues',
      lockPost: 'https://support.healthunlocked.com/article/36-turn-off-replying-on-posts',
    },
  },

  guides: {
    founders: {
      en: 'https://assets.hu-production.be/betelgeuse/admins/guides-en/founders-guideA.pdf',
      pt: 'https://assets.hu-production.be/betelgeuse/admins/guides-pt/fundadores-guiaA.pdf',
      es: 'https://assets.hu-production.be/betelgeuse/admins/guides-es/fundadores-guiaA.pdf',
    },

    pioneers: {
      en: 'https://assets.hu-production.be/betelgeuse/admins/guides-en/Pioneers-Guide.pdf',
      pt: 'https://assets.hu-production.be/betelgeuse/admins/guides-pt/pioneiros-guia.pdf',
      es: 'https://assets.hu-production.be/betelgeuse/admins/guides-es/pioneros-guia.pdf',

    },

    problematic: {
      en: 'https://assets.hu-production.be/betelgeuse/admins/guides-en/problematiccontent-guide.pdf',
      pt: 'https://assets.hu-production.be/betelgeuse/admins/guides-pt/conteudos-problematicos-guia.pdf',
      es: 'https://assets.hu-production.be/betelgeuse/admins/guides-es/contenido-problematico-guia.pdf',
    },

    video: {
      en: '',
      // en: 'https://www.youtube.com/watch?v=sXstR3AH4us',
      es: 'https://www.youtube.com/watch?v=7A2vtPa8hnY',
      pt: 'https://www.youtube.com/watch?v=85tNW2yoXC4',
    },
  },

  sentryURL: sentryURL,

  sentryOptions: sentryOptions,

  discover: {
    communities: [
      'bhf',
      'gstt-nutrition',
      'johns',
      'mount-sinai-stroke',
      'mymsaa',
      'ovacome',
      'share-breast-cancer-support',
      'share-metastatic-support',
      'share-ovarian-cancer-support',
      'share-uterine-cancer-support',
    ],
  },
}, buildConfig);
